<template>
  <div class="knw_widget_inputbar_cancel">
    <transition name="delayed-appear" appear>
      <InputButton variant="solid" @click="handleCancelClick">
        <IconClose width="20px" height="20px" />
        {{ label || t("delayedCancelInput.default") }}
      </InputButton>
    </transition>
  </div>
</template>

<script setup lang="ts">
import IconClose from "@/svg/IconClose.vue";
import signals from "@/common/signals";
import { useMoinBot } from "@/services/bot/botv2";
import type { Intent } from "@/types";
import { useI18n } from "@/composables/useI18n";
import InputButton from "@/components/common/InputButton.vue";

const { t } = useI18n();

const props = defineProps<{
  label: string | undefined;
  intent: Intent | undefined;
}>();

const bot = useMoinBot();
const emit = defineEmits(["onCancel"]);

const handleCancelClick = () => {
  emit("onCancel", props.intent);
  if (props.intent) {
    signals.click("quickreplies", {
      source: "quickreplies",
      text: bot.getInputType.value.label,
    });
  }
};
</script>

<style lang="scss" scoped>
.knw_widget_inputbar_cancel {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 50px;
  padding-right: 8px;
}

.delayed-appear-enter-active,
.delayed-appear-leave-active {
  transition: opacity 0.5s ease;
  transition-delay: 0.5s;
}

.delayed-appear-enter-from,
.delayed-appear-leave-to {
  opacity: 0;
}
</style>
